import { Route } from '@angular/router';
import { StatusCheckComponent } from './status-check/status-check.component';

export const STATUS_CHECK_ROUTE: Route = {
  component: StatusCheckComponent,
  path: 'status-check',
};
